<template>
  <section class="relative overflow-hidden pt-[114px] pb-[114px]">
    <SectionWaves />
    <div class="flex justify-center w-full py-0 md:py-10 bg-[#f5f5f5] z-10 relative">
      <div class="w-full max-w-container">
        <h2 class="landing_h2 text-center max-[767px]:text-center">
          <Translate translate-key="landing_how_it_works.title" />
        </h2>
        <ul
          class="grid grid-cols-1 gap-6 list-none mb-10 p-0 md:grid-cols-3 m-4 md:m-0"
        >
          <li
            class="flex flex-col bg-white rounded-xl p-6 pb-5 shadow-xl md:p-8 md:pb-6"
            :class="$style.stepCardClass"
          >
            <span class="block text-sm font-semibold text-gray-500 mb-2">
              <Translate translate-key="landing_how_it_works.steps.1.step" />
            </span>
            <h3 class="m-0 mb-2 text-lg font-black text-gray-800">
              <Translate translate-key="landing_how_it_works.steps.1.title" />
            </h3>
            <p class="m-0 text-[15px] leading-relaxed text-gray-500">
              <Translate translate-key="landing_how_it_works.steps.1.text" />
            </p>
          </li>
          <li
            class="flex flex-col bg-white rounded-xl p-6 pb-5 shadow-xl md:p-8 md:pb-6"
            :class="$style.stepCardClass"
          >
            <span class="block text-sm font-semibold text-gray-500 mb-2">
              <Translate translate-key="landing_how_it_works.steps.2.step" />
            </span>
            <h3 class="m-0 mb-2 text-lg font-black text-gray-800">
              <Translate translate-key="landing_how_it_works.steps.2.title" />
            </h3>
            <p class="m-0 text-[15px] leading-relaxed text-gray-500">
              <Translate translate-key="landing_how_it_works.steps.2.text" />
            </p>
          </li>
          <li
            class="flex flex-col bg-white rounded-xl p-6 pb-5 shadow-xl md:p-8 md:pb-6"
            :class="$style.stepCardClass"
          >
            <span class="block text-sm font-semibold text-gray-500 mb-2">
              <Translate translate-key="landing_how_it_works.steps.3.step" />
            </span>
            <h3 class="m-0 mb-2 text-lg font-black text-gray-800">
              <Translate translate-key="landing_how_it_works.steps.3.title" />
            </h3>
            <p class="m-0 text-[15px] leading-relaxed text-gray-500">
              <Translate translate-key="landing_how_it_works.steps.3.text" />
            </p>
          </li>
        </ul>
        <ul
          class="flex flex-col md:flex-row items-center justify-center gap-4 mt-10"
        >
          <li>
            <Button
              id="browseAllTradelines"
              as="a"
              :href="linkHref('/tradelines-for-sale?limit=50&offset=0')"
              variant="landing1"
              class="p-6 px-10"
            >
              <Translate translate-key="landing_how_it_works.browse_all" />
            </Button>
          </li>
          <li>
            <Button
              id="getAProfessionalSuggestion"
              variant="landingOutline"
              class="p-6 px-10"
              @click="showQuizModal"
            >
              <Translate
                translate-key="landing_how_it_works.get_professional_tip"
              />
            </Button>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";
import { Button } from "~/shared/components/ui/button";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import SectionWaves from "~/features/landing-page/components/sections/SectionWaves.vue";
import { Dialogs, useDialogsStore } from "~/stores/dialogStore";

const { linkHref } = useNativeRouteLink();

function showQuizModal() {
  useDialogsStore().openDialog(Dialogs.QuizModal);
}
</script>

<style module lang="scss">
@use "~/assets/css/landing-variables.scss" as *;

.stepCardClass {
  position: relative;

  &:not(:last-of-type)::after {
    content: "";
    position: absolute;
    background-color: $brandColor;
    pointer-events: none;
  }
}

@media (max-width: 767px) {
  .stepCardClass:not(:last-of-type)::after {
    left: 50%;
    bottom: 0;
    width: 2px;
    height: 66px;
    transform: translate(-50%, 100%);
  }
}

@media (min-width: 768px) {
  .stepCardClass:not(:last-of-type)::after {
    right: 0;
    top: 50%;
    width: 30px;
    height: 2px;
    transform: translate(100%, -50%);
  }
}
</style>
